export default "__VITE_ASSET__762d6bcb__"